"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

var _Flex = _interopRequireDefault(require("../../../Layout/Flex"));

var _Form = _interopRequireDefault(require("../Form"));

var _reactFeather = require("react-feather");

var _Input = _interopRequireDefault(require("../Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var renderOptionsTree = function renderOptionsTree(tree, key) {
  return tree.map(function (option, i) {
    if (option.options) {
      return React.createElement(React.Fragment, {
        key: key + "[" + i + "].selected"
      }, React.createElement(_Flex.default, {
        sx: {
          alignItems: 'center',
          marginBottom: '8px'
        }
      }, React.createElement(_Form.default.Field, {
        component: _Form.default.Input.Checkbox,
        id: option.name,
        inline: true,
        label: option.name,
        name: key + "[" + i + "].selected"
      })), React.createElement(_Flex.default, {
        sx: {
          flexFlow: 'column nowrap',
          marginLeft: 28
        }
      }, renderOptionsTree(option.options, key + ("[" + i + "].options"))));
    }

    return React.createElement(_Flex.default, {
      key: option.name,
      sx: {
        alignItems: 'center',
        marginBottom: '8px'
      }
    }, React.createElement(_Form.default.Field, {
      component: _Form.default.Input.Checkbox,
      id: option.name,
      inline: true,
      label: option.name,
      name: key + "[" + i + "].selected"
    }));
  });
};

var MultiSelectButton = function MultiSelectButton(_a) {
  var _b = _a.maskText,
      maskText = _b === void 0 ? true : _b,
      text = _a.text,
      _c = _a.variant,
      variant = _c === void 0 ? 'forms.multiselect' : _c,
      width = _a.width,
      props = (0, _tslib.__rest)(_a, ["maskText", "text", "variant", "width"]);
  return React.createElement(_Input.default.Text, (0, _tslib.__assign)({
    as: "div",
    sx: {
      width: width
    },
    variant: variant
  }, props), React.createElement(_Flex.default, {
    sx: {
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, React.createElement(_Box.default, {
    sx: maskText && {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    }
  }, text), React.createElement(_reactFeather.ChevronDown, null)));
};

var MultiSelect = function MultiSelect(_a) {
  var buttonText = _a.buttonText,
      name = _a.name,
      options = _a.options,
      _b = _a.popoverHeight,
      popoverHeight = _b === void 0 ? 300 : _b,
      _c = _a.syncedWidth,
      syncedWidth = _c === void 0 ? 252 : _c,
      variant = _a.variant;

  var _d = React.useState(false),
      selectOpen = _d[0],
      setSelectOpen = _d[1];

  return React.createElement(_Box.default, {
    sx: {
      position: 'relative',
      width: syncedWidth
    }
  }, React.createElement(MultiSelectButton, {
    as: "button",
    onClick: function onClick() {
      return setSelectOpen(function (prev) {
        return !prev;
      });
    },
    text: buttonText,
    width: syncedWidth,
    variant: variant
  }), React.createElement(_Box.default, {
    sx: {
      display: selectOpen ? 'block' : 'none',
      padding: '24px 20px',
      position: 'absolute',
      top: '100%',
      left: '0',
      width: syncedWidth,
      height: popoverHeight,
      background: 'white',
      boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
      borderRadius: 4,
      overflow: 'scroll'
    }
  }, React.createElement(_Flex.default, {
    sx: {
      flexFlow: 'column nowrap'
    }
  }, renderOptionsTree(options, name))));
};

var _default = MultiSelect;
exports.default = _default;